import LinkIcon from '@mui/icons-material/Link';
import { Button, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import copy from 'copy-to-clipboard';
import moment from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ShareLinkResultDialog from 'commons/ShareLinkResultDialog';
import Text from 'commons/Text';
import Colors from 'configs/Colors';
import { ReactComponent as CalendarIcon } from 'images/calendar.svg';
import { ToastTopHelper } from 'utils/utils';

import useCreateShareLink from '../hooks/useCreateShareLink';

const ShareTabCreateShareLink = ({ classes, onClose }) => {
  const { t } = useTranslation();
  const [memorableName, setMemorableName] = useState('');
  const [expiryDate, setExpiryDate] = useState(null);
  const [isOpenResultDialog, setIsOpenResultDialog] = useState(false);
  const [createdLink] = useState('');

  const { mutate: createShareLink } = useCreateShareLink();

  const handleCopyLink = async () => {
    const payload = {
      is_share_all: true,
      recipient_type: 'public',
      expiration_type: expiryDate ? 'custom' : 'never',
      share_type: 'mixed',
      expires_at: expiryDate,
    };
    createShareLink(
      { payload },
      {
        onSuccess: (data) => {
          const SITE_URL = process.env.REACT_APP_SITE_URL;
          const link = `${SITE_URL}/share/${data?.id}`;
          copy(link);
          // setCreatedLink(link);
          // setIsOpenResultDialog(true);
          ToastTopHelper.success(t('link_copied'));
        },
      },
    );
  };

  const handleCloseResultDialog = () => {
    setIsOpenResultDialog(false);
    onClose?.();
  };

  return (
    <>
      <ShareLinkResultDialog
        open={isOpenResultDialog}
        onClose={handleCloseResultDialog}
        createdLink={createdLink}
      />

      <div className={classes.createShareContent}>
        <Text
          type="md"
          color={Colors.Grey10}
        >
          {t('create_share_link_description')}
        </Text>

        <div className={classes.fieldGroup}>
          <Text
            type="sm"
            color={Colors.Grey10}
          >
            {t('memorable_name')}
          </Text>
          <TextField
            value={memorableName}
            onChange={(event) => setMemorableName(event.target.value)}
            placeholder={t('memorable_name_placeholder')}
            className={classes.textField}
            InputProps={{
              className: classes.textFieldInput,
            }}
          />
        </div>

        <div className={classes.fieldGroup}>
          <Text
            type="sm"
            color={Colors.Grey10}
          >
            {t('expiry_date_optional')}
          </Text>
          <DatePicker
            value={expiryDate}
            onChange={(value) => setExpiryDate(value ? moment(value) : null)}
            disablePast
            slots={{
              openPickerIcon: CalendarIcon,
            }}
            slotProps={{
              textField: {
                placeholder: t('set_date'),
                className: classes.textField,
                InputProps: {
                  className: classes.textFieldInput,
                },
              },
            }}
            className={classes.datePicker}
          />
        </div>

        <div className={classes.actions}>
          <Button
            variant="contained"
            startIcon={<LinkIcon />}
            className={classes.copyButton}
            onClick={handleCopyLink}
          >
            {t('copy')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default ShareTabCreateShareLink;
